export default __webpack_public_path__ + "static/media/Walgreens.4b2335f6.svg";